import IntroWizardsStep from '@/components/intro-wizards/intro-wizards-step/intro-wizards-step';
import { Modal } from '@cmpsr/components';
import ModalIntroWizardCover from './components/modal-intro-wizard-cover/modal-intro-wizard-cover';
import ModalIntroWizardStepDescription from './components/modal-intro-wizard-step-description/modal-intro-wizard-step-description';
import ModalIntroWizardStepTitle from './components/modal-intro-wizard-step-title/modal-intro-wizard-step-title';
import useModalIntroWizard from './modal-intro-wizard.controller';

type ModalIntroWizardProps = {
  isOpen: boolean;
  onClose: () => void;
  onFinish: () => void;
};

export default function ModalIntroWizard(props: ModalIntroWizardProps) {
  const { handleNextButtonClick, handleBackButtonClick, activeStep, activeStepIndex, numberOfSteps, buttonText } =
    useModalIntroWizard(props);

  function renderSwitch(activeStep: number) {
    switch (activeStep) {
      case 0: {
        return (
          <ModalIntroWizardCover onNextButtonClick={handleNextButtonClick} onBackButtonClick={handleBackButtonClick} />
        );
      }
      default: {
        return (
          <IntroWizardsStep
            titleNode={<ModalIntroWizardStepTitle activeStep={activeStep} />}
            descriptionNode={<ModalIntroWizardStepDescription activeStep={activeStep} />}
            imageId="pills"
            activeStepIndex={activeStepIndex}
            numberOfSteps={numberOfSteps}
            onNextButtonClick={handleNextButtonClick}
            onBackButtonClick={handleBackButtonClick}
            buttonText={buttonText}
          />
        );
      }
    }
  }

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} size="full" closeOnEsc={false}>
      <Modal.Content>{renderSwitch(activeStep)}</Modal.Content>
    </Modal>
  );
}
